/**
 * Auth Page Translations
 * ======================
 * Login, Register, Verify Email, Forgot Password, Reset Password
 */

import { Translations } from '../shared/i18n';

export const authTranslations: Translations = {
    tr: {
        // Login
        loginTitle: 'Giriş Yapın',
        loginSubtitle: 'Hesabınıza giriş yapın, faturalarınızı yönetin.',
        loginButton: 'Giriş Yap',
        loginLoading: 'Giriş yapılıyor...',
        loginFailed: 'Giriş başarısız',
        emailLabel: 'Email',
        emailPlaceholder: 'ornek@email.com',
        passwordLabel: 'Şifre',
        passwordPlaceholder: 'Şifreniz',
        forgotPassword: 'Şifremi Unuttum',
        orDivider: 'veya',
        googleLogin: 'Google ile giriş yap',
        microsoftLogin: 'Microsoft ile giriş yap',
        googleRegister: 'Google ile kayıt ol',
        microsoftRegister: 'Microsoft ile kayıt ol',
        redirecting: 'Yönlendiriliyor...',
        ssoFailed: 'SSO başlatılamadı',
        noAccount: 'Hesabınız yok mu?',
        createAccount: 'Hesap Oluştur',

        // Register
        registerTitle: 'Hesap Oluşturun',
        registerSubtitle: 'Ücretsiz kayıt olun, hemen başlayın.',
        registerPlanAlmost: 'Planınıza 1 adım uzaktasınız!',
        registerPlanRedirect: 'Kayıt olduktan sonra abonelik sayfasına yönlendirileceksiniz.',
        nameLabel: 'Ad Soyad',
        namePlaceholder: 'Adınız Soyadınız',
        passwordMinLength: 'En az 8 karakter',
        confirmPasswordLabel: 'Şifre Tekrar',
        confirmPasswordPlaceholder: 'Şifrenizi tekrar girin',
        registerButton: 'Hesap Oluştur',
        registerLoading: 'Kayıt yapılıyor...',
        registerFailed: 'Kayıt başarısız',
        nameRequired: 'Ad Soyad gereklidir',
        passwordTooShort: 'Şifre en az 8 karakter olmalıdır',
        passwordsNoMatch: 'Şifreler eşleşmiyor',
        hasAccount: 'Zaten hesabınız var mı?',
        signIn: 'Giriş Yap',
        legalNoticePrefix: 'Bir KontoMatch hesabı oluşturarak',
        legalNoticeGtc: 'Genel Hüküm ve Koşullar',
        legalNoticeAnd: 'ile',
        legalNoticePrivacy: 'Gizlilik Politikası',
        legalNoticeSuffix: '\'nı kabul etmiş olursunuz.',

        // Verify Email
        verifyTitle: 'Email Doğrulama',
        verifyDescription: 'adresine gönderilen 6 haneli kodu girin',
        verifyButton: 'Doğrula',
        verifyLoading: 'Doğrulanıyor...',
        verifyFailed: 'Doğrulama başarısız',
        verifySuccessLoginFailed: 'Doğrulama başarılı ancak giriş yapılamadı. Lütfen tekrar giriş yapın.',
        resendCode: 'Kodu Tekrar Gönder',
        resendLoading: 'Gönderiliyor...',
        resendSuccess: 'Yeni kod gönderildi!',
        resendFailed: 'Kod gönderilemedi',
        codeExpiry: 'Kod geçerlilik süresi:',
        codeExpired: 'Kod süresi doldu',
        backToLogin: 'Girişe Dön',

        // Forgot Password
        forgotTitle: 'Şifremi Unuttum',
        forgotDescription: 'Email adresinizi girin, sıfırlama kodu göndereceğiz',
        sendCode: 'Kod Gönder',
        sendingCode: 'Gönderiliyor...',
        sendFailed: 'İstek başarısız',
        emailSentTitle: 'Email Gönderildi',
        emailSentDescription: 'Eğer {email} adresi kayıtlıysa, şifre sıfırlama kodu gönderildi.',
        enterCode: 'Kodu Gir',

        // Reset Password
        resetTitle: 'Şifre Sıfırlama',
        resetDescription: 'Email adresinize gelen kodu ve yeni şifrenizi girin',
        resetCodeLabel: 'Sıfırlama Kodu',
        resetCodePlaceholder: '6 haneli kod',
        newPasswordLabel: 'Yeni Şifre',
        newPasswordPlaceholder: 'En az 8 karakter',
        confirmNewPasswordLabel: 'Yeni Şifre Tekrar',
        confirmNewPasswordPlaceholder: 'Şifrenizi tekrar girin',
        resetButton: 'Şifre Değiştir',
        resetLoading: 'Şifre değiştiriliyor...',
        resetPasswordTooShort: 'Şifre en az 8 karakter olmalıdır',
        resetPasswordsNoMatch: 'Şifreler eşleşmiyor',
        resetFailed: 'Şifre sıfırlama başarısız',
        resetSuccess: 'Şifreniz başarıyla değiştirildi. Giriş yapabilirsiniz.',

        // Auth Marketing Panel
        loginMktAriaLabel: 'Ürün genel bakışı',
        loginMktTitle: 'Zamanınızı geri kazanın.',
        loginMktSub: 'KontoMatch her makbuzu otonom olarak çıkarır, eşleştirir ve mutabakatını yapar. Finansal verileriniz, mükemmel şekilde organize edilmiş.',
        loginMktBadgeMatching: 'Yapay Zeka Destekli Eşleştirme',
        loginMktBadgeSecurity: 'Banka düzeyinde güvenlik',
        loginMktBadgeSupport: 'Küresel Destek',

        // SSO Callback
        ssoErrB2bAccount: 'Bu hesap B2C platformu için uygun değil. Lütfen Portal üzerinden giriş yapın.',
        ssoErrInvalidState: 'Güvenlik doğrulaması başarısız. Lütfen tekrar deneyin.',
        ssoErrEmailNotFound: 'Hesabınızdan email bilgisi alınamadı.',
        ssoErrNotConfigured: 'SSO yapılandırılmamış.',
        ssoErrMissingCode: 'Yetkilendirme kodu alınamadı.',
        ssoErrUnknown: 'Bilinmeyen bir hata oluştu.',
        ssoSessionFailed: 'Oturum başlatılamadı. Lütfen tekrar deneyin.',
        ssoCompletionFailed: 'Kayıt tamamlanamadı. Lütfen tekrar deneyin.',
        ssoSigningIn: '{provider} ile giriş yapılıyor...',
        ssoLoginFailed: 'Giriş Başarısız',
        ssoBackToLogin: 'Giriş Sayfasına Dön',
        ssoCompleteTitle: 'Hesabınızı Tamamlayın',
        ssoCompleteSubtitle: '{provider} hesabınızla ilk kez giriş yapıyorsunuz. Lütfen bilgilerinizi tamamlayın.',
        ssoPasswordOptional: '(opsiyonel)',
        ssoPasswordHint: 'En az 8 karakter (sonra da belirleyebilirsiniz)',
        ssoCompleteButton: 'Hesabı Tamamla',
        ssoCompleteLoading: 'Hesap oluşturuluyor...',
    },
    en: {
        // Login
        loginTitle: 'Sign In',
        loginSubtitle: 'Sign in to your account and manage your invoices.',
        loginButton: 'Sign In',
        loginLoading: 'Signing in...',
        loginFailed: 'Login failed',
        emailLabel: 'Email',
        emailPlaceholder: 'example@email.com',
        passwordLabel: 'Password',
        passwordPlaceholder: 'Your password',
        forgotPassword: 'Forgot Password',
        orDivider: 'or',
        googleLogin: 'Sign in with Google',
        microsoftLogin: 'Sign in with Microsoft',
        googleRegister: 'Sign up with Google',
        microsoftRegister: 'Sign up with Microsoft',
        redirecting: 'Redirecting...',
        ssoFailed: 'SSO initialization failed',
        noAccount: 'Don\'t have an account?',
        createAccount: 'Create Account',

        // Register
        registerTitle: 'Create Account',
        registerSubtitle: 'Sign up for free, get started now.',
        registerPlanAlmost: "You're 1 step away from your plan!",
        registerPlanRedirect: "After signing up, you'll be redirected to complete your subscription.",
        nameLabel: 'Full Name',
        namePlaceholder: 'Your full name',
        passwordMinLength: 'Minimum 8 characters',
        confirmPasswordLabel: 'Confirm Password',
        confirmPasswordPlaceholder: 'Enter your password again',
        registerButton: 'Create Account',
        registerLoading: 'Creating account...',
        registerFailed: 'Registration failed',
        nameRequired: 'Full name is required',
        passwordTooShort: 'Password must be at least 8 characters',
        passwordsNoMatch: 'Passwords do not match',
        hasAccount: 'Already have an account?',
        signIn: 'Sign In',
        legalNoticePrefix: 'By creating a KontoMatch account, you agree to the',
        legalNoticeGtc: 'General Terms and Conditions',
        legalNoticeAnd: 'and',
        legalNoticePrivacy: 'Privacy Policy',
        legalNoticeSuffix: '.',

        // Verify Email
        verifyTitle: 'Email Verification',
        verifyDescription: 'Enter the 6-digit code sent to',
        verifyButton: 'Verify',
        verifyLoading: 'Verifying...',
        verifyFailed: 'Verification failed',
        verifySuccessLoginFailed: 'Verification successful but login failed. Please sign in again.',
        resendCode: 'Resend Code',
        resendLoading: 'Sending...',
        resendSuccess: 'New code sent!',
        resendFailed: 'Failed to send code',
        codeExpiry: 'Code expires in:',
        codeExpired: 'Code expired',
        backToLogin: 'Back to Login',

        // Forgot Password
        forgotTitle: 'Forgot Password',
        forgotDescription: 'Enter your email address and we\'ll send a reset code',
        sendCode: 'Send Code',
        sendingCode: 'Sending...',
        sendFailed: 'Request failed',
        emailSentTitle: 'Email Sent',
        emailSentDescription: 'If {email} is registered, a password reset code has been sent.',
        enterCode: 'Enter Code',

        // Reset Password
        resetTitle: 'Reset Password',
        resetDescription: 'Enter the code sent to your email and your new password',
        resetCodeLabel: 'Reset Code',
        resetCodePlaceholder: '6-digit code',
        newPasswordLabel: 'New Password',
        newPasswordPlaceholder: 'Minimum 8 characters',
        confirmNewPasswordLabel: 'Confirm New Password',
        confirmNewPasswordPlaceholder: 'Enter your password again',
        resetButton: 'Change Password',
        resetLoading: 'Changing password...',
        resetPasswordTooShort: 'Password must be at least 8 characters',
        resetPasswordsNoMatch: 'Passwords do not match',
        resetFailed: 'Password reset failed',
        resetSuccess: 'Password changed successfully. You can now sign in.',

        // Auth Marketing Panel
        loginMktAriaLabel: 'Product overview',
        loginMktTitle: 'Reclaim your time.',
        loginMktSub: 'KontoMatch autonomously extracts, matches and reconciles every receipt. Your financial data, perfectly organized.',
        loginMktBadgeMatching: 'AI-Powered Matching',
        loginMktBadgeSecurity: 'Bank-grade security',
        loginMktBadgeSupport: 'Global Support',

        // SSO Callback
        ssoErrB2bAccount: 'This account is not eligible for the B2C platform. Please sign in through the Portal.',
        ssoErrInvalidState: 'Security validation failed. Please try again.',
        ssoErrEmailNotFound: 'Could not retrieve email from your account.',
        ssoErrNotConfigured: 'SSO is not configured.',
        ssoErrMissingCode: 'Authorization code could not be retrieved.',
        ssoErrUnknown: 'An unknown error occurred.',
        ssoSessionFailed: 'Session could not be started. Please try again.',
        ssoCompletionFailed: 'Registration could not be completed. Please try again.',
        ssoSigningIn: 'Signing in with {provider}...',
        ssoLoginFailed: 'Sign In Failed',
        ssoBackToLogin: 'Back to Login',
        ssoCompleteTitle: 'Complete Your Account',
        ssoCompleteSubtitle: 'This is your first time signing in with {provider}. Please complete your information.',
        ssoPasswordOptional: '(optional)',
        ssoPasswordHint: 'Minimum 8 characters (you can set it later too)',
        ssoCompleteButton: 'Complete Account',
        ssoCompleteLoading: 'Creating account...',
    },
    de: {
        // Login
        loginTitle: 'Anmelden',
        loginSubtitle: 'Melden Sie sich an und verwalten Sie Ihre Rechnungen.',
        loginButton: 'Anmelden',
        loginLoading: 'Anmeldung läuft...',
        loginFailed: 'Anmeldung fehlgeschlagen',
        emailLabel: 'E-Mail',
        emailPlaceholder: 'beispiel@email.com',
        passwordLabel: 'Passwort',
        passwordPlaceholder: 'Ihr Passwort',
        forgotPassword: 'Passwort vergessen',
        orDivider: 'oder',
        googleLogin: 'Mit Google anmelden',
        microsoftLogin: 'Mit Microsoft anmelden',
        googleRegister: 'Mit Google registrieren',
        microsoftRegister: 'Mit Microsoft registrieren',
        redirecting: 'Weiterleitung...',
        ssoFailed: 'SSO-Initialisierung fehlgeschlagen',
        noAccount: 'Noch kein Konto?',
        createAccount: 'Konto erstellen',

        // Register
        registerTitle: 'Konto erstellen',
        registerSubtitle: 'Kostenlos registrieren und sofort loslegen.',
        registerPlanAlmost: 'Nur noch 1 Schritt zu Ihrem Plan!',
        registerPlanRedirect: 'Nach der Registrierung werden Sie zur Abonnementseite weitergeleitet.',
        nameLabel: 'Vollständiger Name',
        namePlaceholder: 'Ihr vollständiger Name',
        passwordMinLength: 'Mindestens 8 Zeichen',
        confirmPasswordLabel: 'Passwort bestätigen',
        confirmPasswordPlaceholder: 'Passwort erneut eingeben',
        registerButton: 'Konto erstellen',
        registerLoading: 'Konto wird erstellt...',
        registerFailed: 'Registrierung fehlgeschlagen',
        nameRequired: 'Vollständiger Name ist erforderlich',
        passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein',
        passwordsNoMatch: 'Passwörter stimmen nicht überein',
        hasAccount: 'Bereits ein Konto?',
        signIn: 'Anmelden',
        legalNoticePrefix: 'Mit der Erstellung eines KontoMatch-Kontos stimmen Sie den',
        legalNoticeGtc: 'Allgemeinen Geschäftsbedingungen',
        legalNoticeAnd: 'und der',
        legalNoticePrivacy: 'Datenschutzerklärung',
        legalNoticeSuffix: ' zu.',

        // Verify Email
        verifyTitle: 'E-Mail-Verifizierung',
        verifyDescription: 'Geben Sie den 6-stelligen Code ein, der an folgende Adresse gesendet wurde',
        verifyButton: 'Bestätigen',
        verifyLoading: 'Wird überprüft...',
        verifyFailed: 'Verifizierung fehlgeschlagen',
        verifySuccessLoginFailed: 'Verifizierung erfolgreich, aber Anmeldung fehlgeschlagen. Bitte melden Sie sich erneut an.',
        resendCode: 'Code erneut senden',
        resendLoading: 'Wird gesendet...',
        resendSuccess: 'Neuer Code gesendet!',
        resendFailed: 'Code konnte nicht gesendet werden',
        codeExpiry: 'Code gültig bis:',
        codeExpired: 'Code abgelaufen',
        backToLogin: 'Zurück zur Anmeldung',

        // Forgot Password
        forgotTitle: 'Passwort vergessen',
        forgotDescription: 'Geben Sie Ihre E-Mail-Adresse ein, wir senden Ihnen einen Zurücksetzungscode',
        sendCode: 'Code senden',
        sendingCode: 'Wird gesendet...',
        sendFailed: 'Anfrage fehlgeschlagen',
        emailSentTitle: 'E-Mail gesendet',
        emailSentDescription: 'Falls {email} registriert ist, wurde ein Code zum Zurücksetzen des Passworts gesendet.',
        enterCode: 'Code eingeben',

        // Reset Password
        resetTitle: 'Passwort zurücksetzen',
        resetDescription: 'Geben Sie den Code aus Ihrer E-Mail und Ihr neues Passwort ein',
        resetCodeLabel: 'Zurücksetzungscode',
        resetCodePlaceholder: '6-stelliger Code',
        newPasswordLabel: 'Neues Passwort',
        newPasswordPlaceholder: 'Mindestens 8 Zeichen',
        confirmNewPasswordLabel: 'Neues Passwort bestätigen',
        confirmNewPasswordPlaceholder: 'Passwort erneut eingeben',
        resetButton: 'Passwort ändern',
        resetLoading: 'Passwort wird geändert...',
        resetPasswordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein',
        resetPasswordsNoMatch: 'Passwörter stimmen nicht überein',
        resetFailed: 'Passwort konnte nicht zurückgesetzt werden',
        resetSuccess: 'Passwort erfolgreich geändert. Sie können sich jetzt anmelden.',

        // Auth Marketing Panel
        loginMktAriaLabel: 'Produktübersicht',
        loginMktTitle: 'Holen Sie sich Ihre Zeit zurück.',
        loginMktSub: 'KontoMatch extrahiert, gleicht ab und verbucht jeden Beleg autonom. Ihre Finanzdaten, perfekt organisiert.',
        loginMktBadgeMatching: 'KI-gestützter Abgleich',
        loginMktBadgeSecurity: 'Sicherheit auf Bankniveau',
        loginMktBadgeSupport: 'Weltweiter Support',

        // SSO Callback
        ssoErrB2bAccount: 'Dieses Konto ist nicht für die B2C-Plattform geeignet. Bitte melden Sie sich über das Portal an.',
        ssoErrInvalidState: 'Sicherheitsüberprüfung fehlgeschlagen. Bitte versuchen Sie es erneut.',
        ssoErrEmailNotFound: 'E-Mail konnte nicht aus Ihrem Konto abgerufen werden.',
        ssoErrNotConfigured: 'SSO ist nicht konfiguriert.',
        ssoErrMissingCode: 'Autorisierungscode konnte nicht abgerufen werden.',
        ssoErrUnknown: 'Ein unbekannter Fehler ist aufgetreten.',
        ssoSessionFailed: 'Sitzung konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
        ssoCompletionFailed: 'Registrierung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
        ssoSigningIn: 'Anmeldung mit {provider}...',
        ssoLoginFailed: 'Anmeldung fehlgeschlagen',
        ssoBackToLogin: 'Zurück zur Anmeldung',
        ssoCompleteTitle: 'Konto vervollständigen',
        ssoCompleteSubtitle: 'Sie melden sich zum ersten Mal mit {provider} an. Bitte vervollständigen Sie Ihre Informationen.',
        ssoPasswordOptional: '(optional)',
        ssoPasswordHint: 'Mindestens 8 Zeichen (können Sie auch später festlegen)',
        ssoCompleteButton: 'Konto vervollständigen',
        ssoCompleteLoading: 'Konto wird erstellt...',
    },
};
